
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import vSelect from './vselect'
import common from '@/tools/common'
import App from '@/App'
export default {
directives: {
TransferDom
},
components: {
vSelect,
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
Datetime,
XDialog,
App
},
methods: {
doThis: function (index, idlist, name) {
if (name === '内容类别') {
this.contentType = idlist[index]
} else {
this.ruletype = idlist[index]
}
this.queryBtn()
},
handleToggleDrawer (type) {
this.show = true
this.hightype = type
this.$refs.drawerLayout.toggle()
},
chanageSelect (type) {
this.fullsearchtype = type
},
SetFalse () {
this.show = false
},
async queryBtn () {
this.keywordtype = 1
this.doQuery()
this.contentType = '列表浏览'
},
handleSelect (item) {
this.area = item.value

},
async QueryMore (type) {
this.ruletype = type
this.viewtype = 1
this.queryBtn()
},
async next () {
this.currentPage--
await this.doQuery()
},
async querySearchAsync (queryString, callback) {
var list = [{}]

await this.$http.get('/API/FoodsRules/GroupArea', {params: {area: this.Search.value, UserType: this.$route.query.UserType}}).then((response) => {

for (let i of response.data) {
i.value = i.key  
}
list = response.data
this.areas = list

callback(list)
}).catch((error) => {
console.log(error)
})
},
async moreQueryBtn () {
this.currentPage = 1
this.keywordtype = 1
this.viewtype = 1
this.doQuery()
this.contentType = '列表浏览'
},
async perv () {
this.currentPage++
await this.doQuery()
},
async getRulesList () {
const queryPromise = await this.$http.get('/API/FoodsRules/RulesType')

return queryPromise.data
},
async fullSearchChanage () {
this.fullsearchtype = document.getElementById('searchmor_type').value
this.queryBtn()
},
async orderChanage () {
this.currentPage = 1
this.orders = document.getElementById('orders_data').value
this.queryBtn()
},
async doQuery () {
try {
this.$vux.loading.show({ text: ' 数据载入中' })
const queryPromise = await this.$http.get('/API/FoodsRules/GetRuleList'
, {params: {keywordtype: this.keywordtype, ticket: this.ticket, token: this.token, keyword: this.keyword, pageindex: this.currentPage, searchtype: this.fullsearchtype, ordertype: this.orders, pagesize: 8, filename: this.filename, filekeyword: this.filekeyword, title: this.title, area: this.area, years: this.year, department: this.department, effdate: this.effectDate, filetype: this.ruletype}})
this.queryResult = queryPromise.data
console.log(this.queryResult)
if (queryPromise.data.Token !== this.token) {
this.token = queryPromise.data.Token
}
this.$vux.loading.hide()
if (this.queryResult.Data.length === 0) {
this.$vux.alert.show({
title: '通知',
content: '没有符合条件的记录'})
return
}
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}

},
async doFirstQuery () {
this.queryBtn()
},
async showDesc (itemid) {
try {
this.$router.push({name: 'FoodRulesSearchDetails', query: {guid: itemid, token: this.token, ticket: this.ticket, filetypes: 1}})
} catch (err) {
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
},
clear () {
this.Search.value = ''
this.filename = ''
this.filekeyword = ''
this.area = ''
}
},
data () {
return {
queryResult: {Data: [], TotalPage: 0},
ticket: '',
token: '',
queryResultGroup: {Data: [], TotalPage: 0},
p_code: '',
keyword: '',
fullsearchtype: 0,
orders: 1,
viewtype: 1,
show: true,
hightype: 2,
desc: null,
rno: '',
department: '',
yearList: [],
selects: [0, 0, 0],
year: '',
p_name: '',
ruletype: '法律法规',
ruletypeList: ['', '研究报告', '法律法规'],
effect: '',
effectList: ['', '有效', '失效', '部分修改'],
contentType: '',
contenttypeList: ['', '列表浏览', '分组浏览'],
effectDate: null,
publishDate: null,
currentPage: 1,
title: '',
keywordtype: 1,
filename: '',
filekeyword: '',
area: '',
Search: {
key: '', // 地区名称
value: '' 
},
areas: [] 
}
},
beforeCreate: function () {
if (this.$route.query.UserType === common.UserType.Type9) {
App.methods.SetTitle('研究报告查询')
}
if (this.$route.query.UserType === common.UserType.Type10) {
App.methods.SetTitle('法规文本查询')
}
let ss = common.getfoodSession()
if (ss && ss.length > 8) {
} else {
this.$router.push({name: 'FoodRulesLoginPage', query: {UserType: 'type8'}})
}
},
async activated () {
this.ticket = parseInt(new Date().getTime() / 1000).toString()
this.doFirstQuery()
}
}



// WEBPACK FOOTER //
// ./src/components/FoodRulesSearchOfRule.vue